
const lowercase = [101, 108, 101, 99 ,116, 114, 111, 110].map(c => String.fromCharCode(c)).join('');
const uppercase = [69, 108, 101, 99 ,116, 114, 111, 110].map(c => String.fromCharCode(c)).join('');

const sendEvent = () => {
  Jigsaw.addEvents({
    name: uppercase,
    userAgent: navigator.userAgent,
    timestamp: Fraction.Helpers.getUnixTimestamp()
  });
};

const ifPhony = () => {
  if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
      sendEvent();
  }

  // Main process
  if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions[lowercase]) {
      sendEvent();
  }

  // Detect the user agent when the `nodeIntegration` option is set to true
  if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf(uppercase) >= 0) {
      sendEvent();
  }
};

export default ifPhony;